const devConfig = {
  clientId: "0oalqr6n21VUckU3n5d7",
  issuer: "https://dev-55676064.okta.com/oauth2/default",
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ["openid", "profile", "email"],
  responseType: "code",
  pkce: true,
};

const prodConfig = {
  clientId: "0oa1fzag6f88bLzhU358",
  issuer: "https://checkout.okta.com",
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ["openid", "profile", "email"],
  responseType: "code",
  pkce: true,
};

export const oktaConfig =
  window.location.hostname === "localhost" ? devConfig : prodConfig;

export default oktaConfig;
